import React from 'react';
import api from '../../servicios/api';
import documentosMaterialesService from '../../servicios/documentosMaterialesService';

function IconoDocumento({ size = 40 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width={size} height={size}>
      <path fillRule="evenodd" d="M4.5 2A1.5 1.5 0 003 3.5v13A1.5 1.5 0 004.5 18h11a1.5 1.5 0 001.5-1.5V7.621a1.5 1.5 0 00-.44-1.06l-4.12-4.122A1.5 1.5 0 0011.378 2H4.5zM11 2.5V6a1 1 0 001 1h3.5" clipRule="evenodd" />
    </svg>
  );
}

function TabDocumentos({
  documentosSubcontratos,
  documentosMateriales,
  expandedSectionsSubcontratos,
  expandedSectionsMateriales,
  toggleSeccionSubcontrato,
  toggleSeccionMateriales,
  expandirTodasSubcontratos,
  colapsarTodasSubcontratos,
  expandirTodasMateriales,
  colapsarTodasMateriales,
  agruparDocumentosPorSeccion,
  eliminarDocumentosSubcontrato,
  eliminarDocumentosMaterial
}) {
  return (
    <div className="tab-content documentos-page">
      <section className="progress-section-v2">
        <div className="progress-header-bar">
          <h2 className="documentos-page-title">Documentos</h2>
        </div>

        {/* TABLA DE DOCUMENTOS - SUBCONTRATO */}
        <div className="documentos-section">
          <div className="documentos-section-header">
            <div className="critical-title-row" style={{ padding: '0' }}>
              <span className="critical-square" style={{ color: '#374151' }}>■</span>
              <span className="critical-title-text">SubContrato</span>
              <span className="critical-count-badge" style={{ background: '#f9fafb', color: '#374151' }}>{documentosSubcontratos.length} docs</span>
            </div>
            <div className="documentos-acciones-globales">
              <button 
                className="btn-expandir-colapsar"
                onClick={expandirTodasSubcontratos}
                title="Expandir todas las secciones"
              >
                ▼ Expandir todo
              </button>
              <button 
                className="btn-expandir-colapsar"
                onClick={colapsarTodasSubcontratos}
                title="Colapsar todas las secciones"
              >
                ▲ Colapsar todo
              </button>
            </div>
          </div>

          {documentosSubcontratos.length === 0 ? (
            <div className="documentos-mensaje-vacio">
              <div className="documentos-mensaje-vacio-icono">
                <IconoDocumento />
              </div>
              <h3>No hay documentos disponibles</h3>
            </div>
          ) : (
            <div className="documentos-acordeon-container">
              {Object.entries(agruparDocumentosPorSeccion(documentosSubcontratos)).map(([especialidad, seccionData]) => {
                const totalSubcontratos = Object.keys(seccionData.items).length;
                const totalDocumentos = Object.values(seccionData.items).reduce((sum, item) => sum + item.documentos.length, 0);
                const isExpanded = expandedSectionsSubcontratos[especialidad];

                return (
                  <div key={especialidad} className="seccion-acordeon">
                    <div 
                      className={`seccion-header ${isExpanded ? 'expanded' : ''}`}
                      onClick={() => toggleSeccionSubcontrato(especialidad)}
                    >
                      <div className="seccion-header-izquierda">
                        <span className="seccion-chevron">{isExpanded ? '▼' : '▶'}</span>
                        <h4 className="seccion-nombre">{especialidad}</h4>
                      </div>
                      <div className="seccion-header-derecha">
                        <span className="seccion-badge subcontratos">{totalSubcontratos} subcontrato{totalSubcontratos !== 1 ? 's' : ''}</span>
                        <span className="seccion-badge documentos">{totalDocumentos} documento{totalDocumentos !== 1 ? 's' : ''}</span>
                      </div>
                    </div>

                    {isExpanded && (
                      <div className="seccion-content">
                        <div className="documentos-tabla-wrapper">
                          <table className="critical-table-email">
                            <thead>
                              <tr>
                                <th>Subcontrato</th>
                                <th style={{ textAlign: 'center' }}>Envíos</th>
                                <th style={{ textAlign: 'center' }}>Comparativo</th>
                                <th style={{ textAlign: 'center' }}>Negociación</th>
                                <th style={{ textAlign: 'center' }}>Pre-calificación</th>
                                <th style={{ textAlign: 'center' }}>Contrato Firmado</th>
                                <th style={{ textAlign: 'center' }}>Acciones</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Object.entries(seccionData.items).map(([subcontratoId, subcontratoData], index) => {
                                const processes = ['envios', 'comparativo', 'negociacion', 'precalificacion', 'contratoFirmado'];

                                return (
                                  <tr key={subcontratoId} className={index % 2 === 0 ? 'row-even' : 'row-odd'}>
                                    <td className="cell-name">{subcontratoData.nombre}</td>
                                    {processes.map(process => {
                                      const docsDelProceso = subcontratoData.documentos.filter(doc => doc.proceso === process);
                                      const docNoAplica = docsDelProceso.find(doc => doc.noAplica === true);
                                      const docsReales = docsDelProceso.filter(doc => !doc.noAplica);
                                      
                                      return (
                                        <td key={process} style={{ textAlign: 'center' }}>
                                          {docsReales.length > 0 ? (
                                            <div className="documentos-pdf-container">
                                              {docsReales.map((doc, idx) => (
                                                <button
                                                  key={doc._id}
                                                  type="button"
                                                  onClick={async (e) => {
                                                    e.preventDefault();
                                                    try {
                                                      const response = await api.get(`/documentos/${doc._id}`);
                                                      const docCompleto = response.data.documento;
                                                      const base64 = docCompleto.archivoBase64;
                                                      const byteCharacters = atob(base64.split(',')[1] || base64);
                                                      const byteNumbers = new Array(byteCharacters.length);
                                                      for (let i = 0; i < byteCharacters.length; i++) {
                                                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                                                      }
                                                      const byteArray = new Uint8Array(byteNumbers);
                                                      const blob = new Blob([byteArray], { type: docCompleto.mimeType || 'application/pdf' });
                                                      const url = URL.createObjectURL(blob);
                                                      window.open(url, '_blank');
                                                    } catch (error) {
                                                      console.error('Error al abrir archivo:', error);
                                                      alert('Error al abrir el documento');
                                                    }
                                                  }}
                                                  className="documentos-pdf-button"
                                                  title={doc.nombre}
                                                >
                                                  <IconoDocumento size={14} />
                                                  {doc.nombre || `Archivo ${idx + 1}`}
                                                </button>
                                              ))}
                                            </div>
                                          ) : docNoAplica ? (
                                            <span className="documentos-no-aplica" title="Este proceso fue marcado como 'No aplica'">
                                              N/A
                                            </span>
                                          ) : (
                                            <span className="documentos-sin-archivo">—</span>
                                          )}
                                        </td>
                                      );
                                    })}
                                    <td style={{ textAlign: 'center' }}>
                                      <button
                                        className="btn-action btn-delete"
                                        onClick={() => eliminarDocumentosSubcontrato(subcontratoId, subcontratoData.nombre)}
                                        title="Eliminar todos los documentos de este subcontrato"
                                      >
                                        Eliminar
                                      </button>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* TABLA DE DOCUMENTOS - MATERIALES */}
        <div className="documentos-section">
          <div className="documentos-section-header">
            <div className="critical-title-row" style={{ padding: '0' }}>
              <span className="critical-square" style={{ color: '#374151' }}>■</span>
              <span className="critical-title-text">Materiales</span>
              <span className="critical-count-badge" style={{ background: '#f9fafb', color: '#374151' }}>{documentosMateriales.length} docs</span>
            </div>
            <div className="documentos-acciones-globales">
              <button 
                className="btn-expandir-colapsar"
                onClick={expandirTodasMateriales}
                title="Expandir todas las secciones"
              >
                ▼ Expandir todo
              </button>
              <button 
                className="btn-expandir-colapsar"
                onClick={colapsarTodasMateriales}
                title="Colapsar todas las secciones"
              >
                ▲ Colapsar todo
              </button>
            </div>
          </div>

          {documentosMateriales.length === 0 ? (
            <div className="documentos-mensaje-vacio">
              <div className="documentos-mensaje-vacio-icono">
                <IconoDocumento />
              </div>
              <h3>No hay documentos disponibles</h3>
            </div>
          ) : (
            <div className="documentos-acordeon-container">
              {Object.entries(agruparDocumentosPorSeccion(documentosMateriales)).map(([especialidad, seccionData]) => {
                const totalMateriales = Object.keys(seccionData.items).length;
                const totalDocumentos = Object.values(seccionData.items).reduce((sum, item) => sum + item.documentos.length, 0);
                const isExpanded = expandedSectionsMateriales[especialidad];

                return (
                  <div key={especialidad} className="seccion-acordeon">
                    <div 
                      className={`seccion-header ${isExpanded ? 'expanded' : ''}`}
                      onClick={() => toggleSeccionMateriales(especialidad)}
                    >
                      <div className="seccion-header-izquierda">
                        <span className="seccion-chevron">{isExpanded ? '▼' : '▶'}</span>
                        <h4 className="seccion-nombre">{especialidad}</h4>
                      </div>
                      <div className="seccion-header-derecha">
                        <span className="seccion-badge subcontratos">{totalMateriales} material{totalMateriales !== 1 ? 'es' : ''}</span>
                        <span className="seccion-badge documentos">{totalDocumentos} documento{totalDocumentos !== 1 ? 's' : ''}</span>
                      </div>
                    </div>

                    {isExpanded && (
                      <div className="seccion-content">
                        <div className="documentos-tabla-wrapper">
                          <table className="critical-table-email">
                            <thead>
                              <tr>
                                <th>Material</th>
                                <th style={{ textAlign: 'center' }}>Cubicación</th>
                                <th style={{ textAlign: 'center' }}>Rev. Cubicación</th>
                                <th style={{ textAlign: 'center' }}>Solped</th>
                                <th style={{ textAlign: 'center' }}>OC Aprobada</th>
                                <th style={{ textAlign: 'center' }}>Material en Obra</th>
                                <th style={{ textAlign: 'center' }}>Acciones</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Object.entries(seccionData.items).map(([materialId, materialData], index) => {
                                const processes = ['cubicacion', 'revCubicacion', 'solped', 'ocAprobada', 'materialEnObra'];

                                return (
                                  <tr key={materialId} className={index % 2 === 0 ? 'row-even' : 'row-odd'}>
                                    <td className="cell-name">{materialData.nombre}</td>
                                    {processes.map(process => {
                                      const docsDelProceso = materialData.documentos.filter(doc => doc.proceso === process);
                                      const docNoAplica = docsDelProceso.find(doc => doc.noAplica === true);
                                      const docsReales = docsDelProceso.filter(doc => !doc.noAplica);
                                      
                                      return (
                                        <td key={process} style={{ textAlign: 'center' }}>
                                          {docsReales.length > 0 ? (
                                            <div className="documentos-pdf-container">
                                              {docsReales.map((doc, idx) => (
                                                <button
                                                  key={doc._id}
                                                  type="button"
                                                  onClick={async (e) => {
                                                    e.preventDefault();
                                                    try {
                                                      const response = await documentosMaterialesService.obtenerDocumento(doc._id);
                                                      const docCompleto = response.documento;
                                                      const base64 = docCompleto.archivoBase64;
                                                      const byteCharacters = atob(base64.split(',')[1] || base64);
                                                      const byteNumbers = new Array(byteCharacters.length);
                                                      for (let i = 0; i < byteCharacters.length; i++) {
                                                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                                                      }
                                                      const byteArray = new Uint8Array(byteNumbers);
                                                      const blob = new Blob([byteArray], { type: docCompleto.mimeType });
                                                      const url = URL.createObjectURL(blob);
                                                      window.open(url, '_blank');
                                                    } catch (error) {
                                                      console.error('Error al abrir archivo:', error);
                                                      alert('Error al abrir el documento');
                                                    }
                                                  }}
                                                  className="documentos-pdf-button materiales"
                                                  title={doc.nombre}
                                                >
                                                  <IconoDocumento size={14} />
                                                  {doc.nombre || `Archivo ${idx + 1}`}
                                                </button>
                                              ))}
                                            </div>
                                          ) : docNoAplica ? (
                                            <span className="documentos-no-aplica" title="Este proceso fue marcado como 'No aplica'">
                                              N/A
                                            </span>
                                          ) : (
                                            <span className="documentos-sin-archivo">—</span>
                                          )}
                                        </td>
                                      );
                                    })}
                                    <td style={{ textAlign: 'center' }}>
                                      <button
                                        className="btn-action btn-delete"
                                        onClick={() => eliminarDocumentosMaterial(materialId, materialData.nombre)}
                                        title="Eliminar todos los documentos de este material"
                                      >
                                        Eliminar
                                      </button>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>

      </section>
    </div>
  );
}

export default TabDocumentos;
